import { Typography } from "@mui/material"

export function FeatureDescriptionLine({ item }) {
    return (
        <li
            style={{
                marginBottom: "0.5rem",
                lineHeight: 1.5,
            }}
        >
            <Typography>{item}</Typography>
        </li>
    )
}
